var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo",on:{"click":function($event){return _vm.goPage('Home')}}},[_c('el-image',{attrs:{"src":_vm.logoSrc,"fit":"cover"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }